module.exports = {
      id: "home-more-bg2-usage",
      viewBox: "0 0 500 304",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#home-more-bg2-usage",
      toString: function () {
        return this.url;
      }
    }